module.exports = __webpack_public_path__ + "img/IMG_1645_WoodMatted.f07153bf.jpg";